import { defineMessages } from "react-intl";

const messages = defineMessages({
    removeCard: {
        id: "tasks.rhythmSorting.removeCard",
    },
});

export default messages;
